// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".left-rail--interactive-mode{opacity:.4;pointer-events:none;transition:opacity 200ms ease}", "",{"version":3,"sources":["webpack://./_editor/components/carousel/elements_library/panels/AssessmentsPanel.scss"],"names":[],"mappings":"AAWA,6BACE,UAAA,CACA,mBAAA,CACA,6BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
